export const styles = {
  mainContainer:
    "relative flex flex-col items-center justify-center h-screen bg-cover lg:bg-right bg-resetPass",

  //tech dome logo
  logoContainer: "absolute flex items-end space-x-2 top-5 left-10 ",
  logoImg: "w-8 h-8 animate-pulse",
  logoCaption: "text-lg text-blue-200 uppercase",

  //reset password form
  formContainer: "flex flex-col items-center justify-center xl:w-1/4",
  hasResetCaption: "text-5xl font-bold text-yellow-200 mb-4",
  enterPwCaption: "text-xl text-blue-100",
  loginBtn:
    "rounded-full bg-gradient-to-r from-purple-500 to-blue-500 py-2.5 text-white w-full",
  inputContainer:
    "flex my-1 border border-white rounded-full focus-within:border-yellow-200 focus-within:ring-yellow-200 ring-1",
  pwInput:
    "w-5/6 text-white bg-transparent border-none rounded-full focus:border-none focus:ring-0 placeholder:text-gray-400",
  eyeIconContainer: "flex flex-col items-center justify-center w-1/5",
  eyeIcon: "text-xl text-gray-300 hover:text-white hover:cursor-pointer",
  saveBtn:
    "rounded-full bg-blue-500 py-2.5 text-white w-full my-6 hover:bg-blue-600",
};
